export default __webpack_public_path__ + "static/icecream-health-3-desktop-788be5d5849d5de30f007732e86120d3.png";